(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDocumentTemplateSelector', drvDocumentTemplateSelector);

    drvDocumentTemplateSelector.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvDocumentTemplateSelector
     *
     * @description
     * A component used for selecting a document template from the supplied list of document templates.
     *
     * # Scope Params
     * {string} label - The label/name to be shown for the control. Optional.
     * {object} value - The selected value.
     * {array} documentTemplates - List of document templates which will be shown by the select control
     * {string} placeHolder - The label/name to be shown in the control when no value has been selected. Optional.
     * {bool} disabled - Disables the control. Optional.
     * {bool} ngRequired - Value must be selected. Optional.
     * {function} onChange - Callback which is invoked when the ng model value has changed. Optional
     * {array/string} valueProperties - Can be array for multiple properties or string for a single property.
     *                                  They will be used to construct a custom value object, this is the format which will be used with value.
     *                                  If not supplied, the unmodified item will be used. Optional.
     */
    function drvDocumentTemplateSelector() {
        var directive = {
            restrict: 'E',
            controller: drvDocumentTemplateSelectorCtrl,
            controllerAs: 'drvCtrl',
            scope: {},
            bindToController: {
                label: '@?',
                value: '=',
                selectedEntity: '=',
                documentTemplates: '<',
                placeHolder: '@?',
                disabled: '<?',
                ngRequired: '<?',
                onChange: '&?',
                valueProperties: '<?'
            },
            template:
                '<drv-selector value="drvCtrl.value" items="drvCtrl.documentTemplates" label="{{drvCtrl.label}}" place-holder="{{drvCtrl.placeHolder ? drvCtrl.placeHolder : \'Select a document template ...\'}}" ng-required="drvCtrl.ngRequired" value-properties="drvCtrl.valueProperties" search-properties="[\'Name\', \'Description\']" on-change="drvCtrl.onChange()">' +
                '   <selected-template>' +
                '       {{item.Name}}' +
                '   </selected-template>' +
                '   <dropdown-item-template>' +
                '       <md-list-item flex="100" class="sub-view-list">' +
                '           <div class="md-list-item-text">' +
                '               <p class="list-item-name"><span ng-if="item.DeletedDate" class="error-messsage-div">(Deleted) </span>{{item.Name}}</p>' +
                '               <p class="list-item-description">{{item.Description}}</p>' +
                '           </div>' +
                '           <md-divider></md-divider>' +
                '       </md-list-item>' +
                '   </dropdown-item-template>' +
                '</drv-selector>'
        };

        drvDocumentTemplateSelectorCtrl.$inject = [];

        return directive;

        function drvDocumentTemplateSelectorCtrl() {
            /* jshint validthis:true */
            var drvCtrl = this;

            activate();

            function activate() {

            }
        }
    }
})();